import React, { useMemo } from 'react';
import Plot from 'react-plotly.js';

const UncertaintyViolins = ({ assetNames, simulations, chartHeight }) => {
  const limitedAssetNames = assetNames.slice(0, 4);
  const getAssetData = (assetName) => {
    const assetIndex = assetNames.indexOf(assetName);
    return simulations.map(sim => sim[assetIndex]);
  };

  const tickerColors = [
    '#2E3192', // deep blue
    '#1BAEA0', // teal
    '#8CC63F', // lime green
    '#F7931E'  // orange
  ];

  const traces = useMemo(() => {
    const timeSteps = simulations[0]?.length || 0;
    const snapshots = [0, Math.floor(timeSteps * 0.25), Math.floor(timeSteps * 0.5),
                      Math.floor(timeSteps * 0.75), timeSteps - 1];

    return limitedAssetNames.flatMap((asset, assetIndex) => {
      const assetData = getAssetData(asset);

      // Create violin plot for each time step
      return snapshots.map((step, stepIndex) => {
        const stepData = assetData.slice(0, step + 1);

        return {
          type: 'violin',
          x: Array(stepData.length).fill(`T${step}`),
          y: stepData,
          name: asset,
          side: 'positive',
          line: {
            color: tickerColors[assetIndex],
            width: 1
          },
          fillcolor: tickerColors[assetIndex],
          opacity: 0.6,
          meanline: {
            visible: true,
            color: tickerColors[assetIndex],
            width: 2
          },
          box: {
            visible: true
          },
          points: false,
          spanmode: 'soft',
          scalegroup: `group${stepIndex}`,
          showlegend: stepIndex === 0,
          xaxis: 'x',
          yaxis: 'y'
        };
      });
    });
  }, [simulations, limitedAssetNames]);

  const layout = {
    title: 'Distribution Evolution Over Time',
    xaxis: {
      title: 'Time Step',
      showgrid: true,
      zeroline: false
    },
    yaxis: {
      title: 'Value',
      showgrid: true,
      zeroline: false
    },
    height: chartHeight,
    violingap: 0,
    violingroupgap: 0.2,
    showlegend: true,
    legend: {
      title: { text: 'Assets' },
      x: 1.1,
      y: 1,
      xanchor: 'left',
      yanchor: 'top'
    },
    margin: { l: 50, r: 150, t: 50, b: 50 },
    paper_bgcolor: 'white',
    plot_bgcolor: 'white',
  };

  return (
    <Plot
      data={traces}
      layout={layout}
      useResizeHandler={true}
      style={{ width: '100%', height: '100%' }}
      config={{
        responsive: true,
        displayModeBar: false
      }}
    />
  );
};

export default UncertaintyViolins;